export default "__VITE_ASSET__PufFtaBI__"